import '../styles/index.scss'

import './core/voice'
import './core/animation'
import './core/lazy-load'
import './components'
import { matchMedia } from './utils/machMedia'
import './core/snackbar'

document.fonts.ready.then(() => {
  window.dispatchEvent(new Event('resize'))
})
const orientationChangeHandler = () => {
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'))
  }, 100)
}

matchMedia('(orientation: portrait)')(orientationChangeHandler)
